<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <slot></slot>
      </div>
    </template>
    <v-card class="wrapperClaim">
      <v-card-title class="headline d-flex justify-center">
        <h1 class="boxedContent pb-5 font-weight-bold text-center">
          <translate>Claim</translate>
        </h1>
      </v-card-title>
      <v-card-text class="pb-0 px-0 px-md-16 px-lg-16 px-xl-16">
        <h2 class="text-h4 font-weight-bold black--text text-center pb-5">
          <span>{{ courseDetail.name || "" }}</span>
        </h2>

        <v-form ref="form" lazy-validation>
          <label class="titleForm required-field"
            ><translate>Name</translate></label
          >
          <v-text-field outlined required dense v-model="fullname" />

          <label class="titleForm required-field"
            ><translate>Phone</translate></label
          >
          <v-text-field
            outlined
            required
            dense
            :rules="phoneRules"
            v-model="phone"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <div class="d-flex justify-center mt-4">
          <v-btn color="primary" @click="action(true)" class="mr-5" height="40">
            <translate>Claim</translate>
          </v-btn>

          <v-btn
            color="#E0E0E0"
            @click="action(false)"
            height="40"
            class="btn-cancel"
          >
            <translate>Cancel</translate>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import Vue from 'vue';
export default {
  props: {
    value: {}
  },
  data() {
    return {
      dialog: false,
      fullname: null,
      phone: null,
      phoneRules: [
        v => !!v || Vue.prototype.$gettext("Field is required"),
        v =>
          /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/.test(v) ||
          Vue.prototype.$gettext("The value must be an phone number")
      ]
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    courseDetail() {
      return this.$store.state.golfcourse.courseDetail;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dialog = val;
      }
    }
  },
  mounted() {
    this.fullname = this.user.firstName + " " + this.user.lastName;
    this.phone = this.user.phone;
  },
  methods: {
    async action(temp) {
      if (temp == true) {
        if (this.$refs.form.validate()) {
          this.dialog = false;

          let data = {
            phone: this.phone,
            course: this.courseDetail.id
          };
          const response = this.$store.dispatch("requestAdminGolfCourse", data);
          if (response.error) {
            this.$toast.alert(result.error.message);
          } else {
            this.dialog = false;
            this.$emit("action", temp);
          }
        }
      } else {
        this.dialog = false;
        this.$emit("action", temp);
      }
    }
  }
};
</script>
